import {
  StyledReorderConfirmContent,
  StyledReorderFooter,
  StyledConfirmButton,
  StyledCancelButton,
  StyledConfirmMessage,
} from './styles';

interface Props {
  onConfirm: () => void;
  onClose: () => void;
  conveyanceType: string;
  orderConveyance: string;
}

export const ReorderConfirmConveyance = ({
  onConfirm,
  onClose,
  conveyanceType,
  orderConveyance,
}: Props) => {
  return (
    <StyledReorderConfirmContent>
      <StyledConfirmMessage>
        Changing your order from <b>{conveyanceType}</b> to <b>{orderConveyance}</b> may update item
        availability, fees, and timing.
      </StyledConfirmMessage>

      <StyledReorderFooter>
        <StyledCancelButton type="button" onClick={onClose}>
          Cancel
        </StyledCancelButton>

        <StyledConfirmButton data-css-override="StyledPrimaryButton" onClick={() => onConfirm()}>
          Confirm
        </StyledConfirmButton>
      </StyledReorderFooter>
    </StyledReorderConfirmContent>
  );
};
